import { useQuizResults } from '@mentimeter/quiz';
import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { useLeaderboardResults } from './useLeaderboardResults';
import { ViewOnlyPresentation } from './ViewOnlyPresentation';
import { LEADERBOARD_PREVIEW_RESULT } from './constants';
import type { QuizLeaderboardPresentationProps } from './types';

interface ViewOnlyPresentationDataHandlerProps
  extends QuizLeaderboardPresentationProps {
  timeBasedScoring: boolean;
}

export const ViewOnlyPresentationDataHandler = ({
  title,
  styledTitle,
  label,
  description,
  slidePublicKey,
  textSizeOffset,
  timeBasedScoring,
}: ViewOnlyPresentationDataHandlerProps) => {
  const { useConfig, InteractiveCanvasComponents, isPreviewResultsEnabled } =
    usePresentationContext();

  const { enableAnimations } = useConfig();
  const { data: quizResults } = useQuizResults<QuizPlayersScoreData>();
  const leaderboardResults = useLeaderboardResults(quizResults);

  const resultsToShow = isPreviewResultsEnabled
    ? LEADERBOARD_PREVIEW_RESULT
    : leaderboardResults;

  return (
    <ViewOnlyPresentation
      title={title}
      styledTitle={styledTitle}
      label={label}
      description={description}
      slidePublicKey={slidePublicKey}
      textSizeOffset={textSizeOffset}
      shouldAnimate={enableAnimations}
      leaderboardResults={resultsToShow ?? []}
      timeBasedScoring={timeBasedScoring}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
};
